module.exports = __webpack_public_path__ + "static/img/henyuan2.48820b60.png";